(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["look_product"] && !Shopify.designMode) return;
  try {
    class TotalLook extends HTMLElement {
  constructor() {
    super();
    this.addAllButton = this.querySelector('.add-all-to-cart');
    this.variantDrawer = this.parentNode.querySelector('look-variant-drawer');
    this.products = [];
    
    if (this.addAllButton) {
      this.addAllButton.addEventListener('click', this.handleAddAllClick.bind(this));
      }
      
      this.initializeProducts();
    }

    initializeProducts() {
      const productItems = this.querySelectorAll('.total-look-product-item');
      this.products = Array.from(productItems).map(item => {
        const productId = item.getAttribute('data-product-id');
        const variantId = item.getAttribute('data-variant-id');
        return {
          id: productId,
          variantId: variantId,
          element: item
        };
      });
    }

        handleAddAllClick() {
      // Always open the drawer to let user see and select products
      // The drawer will handle whether to show variant options or not
      this.openVariantDrawer();
    }

    openVariantDrawer() {
      if (this.variantDrawer) {
        this.variantDrawer.open();
        this.initializeVariantDrawer();
      }
    }

    initializeVariantDrawer() {
      if (!this.variantDrawer) return;

      const addButton = this.variantDrawer.querySelector('#AddSelectedToCart');
      const overlay = this.variantDrawer.querySelector('.look-variant-drawer__overlay');
      const closeButton = this.variantDrawer.querySelector('.drawer__close');

      addButton?.addEventListener('click', this.addSelectedVariantsToCart.bind(this));
      overlay?.addEventListener('click', () => this.closeVariantDrawer());
      closeButton?.addEventListener('click', () => this.closeVariantDrawer());

      this.initializeProductSelection();
      this.updateAddButtonText();
    }

    initializeProductSelection() {
      const productCheckboxes = this.variantDrawer.querySelectorAll('.product-checkbox');
      
      productCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', this.updateAddButtonText.bind(this));
      });
    }





    getSelectedVariantId(productSection, productId) {
      const productData = this.getProductData(productId);
      if (!productData?.options?.length || !productData?.variants?.length) {
        return null;
      }

      const selectedOptions = [];
      
      productData.options.forEach((option) => {
        const optionName = typeof option === 'string' ? option : option?.name;
        if (!optionName) return;

        const dropdown = productSection.querySelector(`[data-option-name="${optionName}"]`);
        if (dropdown?.value) {
          selectedOptions.push(dropdown.value);
          return;
        }

        const infoElement = productSection.querySelector('.variant-info-value');
        if (infoElement?.textContent) {
          selectedOptions.push(infoElement.textContent.trim());
        }
      });

      return productData.variants.find(variant => 
        variant.options?.length === selectedOptions.length &&
        variant.options.every((option, index) => option === selectedOptions[index])
      )?.id || null;
    }

    getProductData(productId) {
      const productSection = this.variantDrawer.querySelector(`[data-product-id="${productId}"]`);
      if (!productSection?.dataset.productData) return null;
      
      try {
        return JSON.parse(productSection.dataset.productData);
      } catch (e) {
        return null;
      }
    }

    updateAddButtonText() {
      const count = this.variantDrawer.querySelectorAll('.product-checkbox:checked').length;
      const countElement = this.variantDrawer.querySelector('#SelectedCount');
      if (countElement) countElement.textContent = count;
    }

    async addSelectedVariantsToCart() {
      const addButton = this.variantDrawer.querySelector('#AddSelectedToCart');
      if (!addButton) return;

      this.setDrawerButtonLoading(true);
    
    const items = [];
      const selectedCheckboxes = this.variantDrawer.querySelectorAll('.product-checkbox:checked');
      
      selectedCheckboxes.forEach(checkbox => {
        const productId = checkbox.getAttribute('data-product-id');
        const productSection = this.variantDrawer.querySelector(`[data-product-id="${productId}"]`);
        
        if (!productSection) return;

        const variantDropdowns = productSection.querySelectorAll('.variant-dropdown');
        
        if (variantDropdowns.length > 0) {
          // Product with variants - get selected variant
          const selectedVariantId = this.getSelectedVariantId(productSection, productId);
          if (selectedVariantId) {
            items.push({ id: selectedVariantId, quantity: 1 });
          }
        } else {
          // Single variant product
          const productElement = this.querySelector(`[data-product-id="${productId}"]`);
          const variantId = productElement?.getAttribute('data-variant-id');
      if (variantId) {
            items.push({ id: variantId, quantity: 1 });
          }
      }
    });
    
    if (items.length === 0) {
        this.setDrawerButtonLoading(false);
      return;
    }
    
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js?sections=cart-drawer,cart-icon-bubble', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });
      
      if (response.ok) {
        const result = await response.json();
        
          // Close the variant drawer
          this.closeVariantDrawer();
        
          // Open the cart drawer
          const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.renderContents(result);
          if (cartDrawer.classList.contains('is-empty')) {
            cartDrawer.classList.remove('is-empty');
          }
        }
      } else {
        console.error('Error adding products to cart');
      }
    } catch (error) {
      console.error('Error adding products to cart:', error);
    } finally {
        this.setDrawerButtonLoading(false);
      }
    }

    closeVariantDrawer() {
      if (this.variantDrawer) {
        this.variantDrawer.close();
      }
    }

    async addAllToCart() {
      const productItems = this.querySelectorAll('.total-look-product-item');
      if (!productItems.length) return;
      
      this.setButtonLoading(true);
      
      const items = [];
      
      productItems.forEach(item => {
        const variantId = item.getAttribute('data-variant-id');
        if (variantId) {
        items.push({
          id: variantId,
            quantity: 1
        });
        }
      });
      
      if (items.length === 0) {
        console.error('No valid product variants found');
        this.setButtonLoading(false);
        return;
      }
      
      try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js?sections=cart-drawer,cart-icon-bubble', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });
      
      if (response.ok) {
        const result = await response.json();
        
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.renderContents(result);
          if (cartDrawer.classList.contains('is-empty')) {
            cartDrawer.classList.remove('is-empty');
          }
        }
      } else {
          console.error('Error adding products to cart');
      }
    } catch (error) {
        console.error('Error adding products to cart:', error);
    } finally {
        setTimeout(() => {
          this.setButtonLoading(false);
        }, 500);
    }
  }
  
  setButtonLoading(isLoading) {
    if (isLoading) {
      this.addAllButton.setAttribute('disabled', 'disabled');
      this.addAllButton.classList.add('loading');
      this.addAllButton.setAttribute('aria-busy', 'true');
      const loadingText = this.addAllButton.getAttribute('data-loading-text');
      if (loadingText) {
        this.addAllButton.setAttribute('aria-label', loadingText);
      }
    } else {
      this.addAllButton.removeAttribute('disabled');
      this.addAllButton.classList.remove('loading');
      this.addAllButton.removeAttribute('aria-busy');
        this.addAllButton.setAttribute('aria-label', 'Add all products to cart');
    }
  }

        setDrawerButtonLoading(isLoading) {
      const addButton = this.variantDrawer.querySelector('#AddSelectedToCart');
      if (!addButton) return;

      addButton.disabled = isLoading;
      addButton.classList.toggle('loading', isLoading);
      addButton.setAttribute('aria-busy', isLoading);
    }
  }

  class LookVariantDrawer extends HTMLElement {
    open() {
      this.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.querySelector('button, input, select, textarea, [tabindex]:not([tabindex="-1"])')?.focus();
    }

    close() {
      this.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }
  
  customElements.define('shpflt-total-look', TotalLook);
  customElements.define('look-variant-drawer', LookVariantDrawer);
  } catch(e) { console.error(e); }
})();

})();
